import { useQuery } from "@tanstack/react-query";
import taskerService from "../../../services/taskerService";

export function useReviewerTaskType(taskTypeId: string | undefined) {
  return useQuery({
    queryKey: ["reviewer-task-type", taskTypeId],
    queryFn: () =>
      taskerService.getTaskType(taskTypeId as string, "reviewer"),
    enabled: Boolean(taskTypeId),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
  });
}

// queryKeyPrefix MUST be unique per caller to avoid cross-cache collisions.
export function useLatestFormData(
  queryKeyPrefix: string,
  taskId: string | undefined,
  formId: string | undefined,
) {
  return useQuery({
    queryKey: [queryKeyPrefix, taskId, formId],
    queryFn: async () => {
      const rows = await taskerService.searchFormData(
        taskId as string,
        formId as string,
        "reviewer",
      );
      const latest = [...rows].sort((a, b) => {
        const ta = new Date((a.created_at as string) ?? 0).getTime();
        const tb = new Date((b.created_at as string) ?? 0).getTime();
        return tb - ta;
      })[0];
      return (latest?.form_data ?? {}) as Record<string, unknown>;
    },
    enabled: Boolean(taskId && formId),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
